<template>
<div>
<b-form @submit.prevent="false">
  <b-form-group label="望遠鏡">
    <b-form-select v-model="telescopeId" :options="telescopeList" @change="$emit('telescopeChanged', $event)"></b-form-select>
  </b-form-group>
</b-form>
<table class="table table-striped">
  <thead>
    <th>撮影対象</th>
    <th>開始日時</th>
    <th>撮影時間</th>
    <th>撮影枚数</th>
  </thead>
  <tbody>
    <tr v-for="booking in bookings" :data-id="booking.ID">
      <td>{{ booking.TargetName }}</td>
      <td>{{ booking.Time.Start }}</td>
      <td><template v-if="booking.Exposure.inverse">1/</template>{{ booking.Exposure.n }}</td>
      <td>{{ booking.Repeat }}</td>
    </tr>
  </tbody>
</table>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'booking-list',
  props: ['bookings', 'telescopeList', 'telescopeId']
}
</script>



// WEBPACK FOOTER //
// src/components/BookingList.vue